(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9272],{

/***/ 62906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ GatedContentProvider; },
/* harmony export */   "v4": function() { return /* binding */ useGatedContent; }
/* harmony export */ });
/* unused harmony export GatedContentContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* eslint-disable @typescript-eslint/no-empty-function */

var GatedContentContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  showContent: false,
  updateRegistered: function updateRegistered() {}
});
var GatedContentProvider = GatedContentContext.Provider;
var useGatedContent = function useGatedContent() {
  var gatedContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GatedContentContext);

  if (!gatedContent) {
    throw new Error("Gated content isn't available. Please set it via GatedContentContext component.");
  }

  return gatedContent;
};

/***/ }),

/***/ 63946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ./src/contexts/gatedContent.ts
var gatedContent = __webpack_require__(62906);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      demoButton = _ref.demoButton,
      after = _ref.after;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        color: "primary",
        size: "medium",
        variant: "filled",
        expanded: true,
        href: demoButton.url,
        children: demoButton.text
      })]
    }), after]
  });
};

/* harmony default export */ var components_Navigation_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var Navigation_DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/DesktopNavigation.tsx







var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement,
      demoButton = _ref.demoButton,
      after = _ref.after;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Aside */.xN, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          color: "primary",
          size: "medium",
          variant: "filled",
          href: demoButton.url,
          children: demoButton.text
        })
      })]
    }), after]
  });
};

/* harmony default export */ var components_Navigation_DesktopNavigation = (DesktopNavigation);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/NavigationBrandGrowthMasters.tsx












var NavigationBrandGrowthMasters = function NavigationBrandGrowthMasters(_ref) {
  var announcement = _ref.announcement,
      after = _ref.after;

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      basePath = _usePageConfig.basePath;

  var _useGatedContent = (0,gatedContent/* useGatedContent */.v4)(),
      showContent = _useGatedContent.showContent;

  var router = (0,next_router.useRouter)();
  var demoButton = (0,react.useMemo)(function () {
    var copy = {
      text: "",
      url: ""
    };

    if (showContent || router.pathname.includes("sign-up")) {
      copy.text = "Grow with Segment";
      copy.url = (0,getAbsoluteUrl/* default */.Z)("/demo/", {
        baseUrl: "https://segment.com",
        basePath: ""
      });
    } else {
      copy.text = "Sign up";
      copy.url = "".concat(basePath, "/growth-masters/sign-up/");
    }

    return copy;
  }, [showContent, basePath, router]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Navigation_MobileNavigation, {
        demoButton: demoButton,
        announcement: announcement,
        after: after
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Navigation_DesktopNavigation, {
        demoButton: demoButton,
        announcement: announcement,
        after: after
      })
    })]
  });
};

/* harmony default export */ var Navigation_NavigationBrandGrowthMasters = (NavigationBrandGrowthMasters);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Subnav/index.ts + 20 modules
var Subnav = __webpack_require__(49833);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Subnavigation/data.ts


var data = function data(pageConfig) {
  return [{
    label: "Home",
    id: "growth-masters-home",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/", pageConfig)
  }, {
    label: "Curriculum",
    id: "curriculum",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/curriculum/", pageConfig)
  }, {
    label: "Speakers",
    id: "speakers",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/speakers/", pageConfig)
  }, {
    label: "Contact",
    id: "contact",
    href: (0,getAbsoluteUrl/* default */.Z)("/contact/", {
      baseUrl: "https://segment.com",
      basePath: ""
    })
  }];
};

/* harmony default export */ var Subnavigation_data = (data);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Subnavigation/Subnavigation.tsx




var copy = {
  title: "Growth Masters"
};

var Subnavigation = function Subnavigation() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
    "aria-label": copy.title,
    label: copy.title,
    children: Subnavigation_data(pageConfig).map(function (item) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        label: item.label,
        href: item.href
      }, item.label);
    })
  });
};

/* harmony default export */ var Subnavigation_Subnavigation = (Subnavigation);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Layout/assets/OgGrowthMasters.png
var OgGrowthMasters = __webpack_require__(60777);
var OgGrowthMasters_default = /*#__PURE__*/__webpack_require__.n(OgGrowthMasters);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Layout/Layout.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












// GrowthMasters pages are hosted on the different domain then the rest of the app
// so we don't want to use an absolute urls for the links
var customPageConfig = {
  baseUrl: ""
};

var Layout = function Layout(_ref) {
  var _ref$subnav = _ref.subnav,
      subnav = _ref$subnav === void 0 ? true : _ref$subnav,
      _ref$pageName = _ref.pageName,
      pageName = _ref$pageName === void 0 ? "" : _ref$pageName,
      children = _ref.children;
  var defaultPageConfig = (0,page/* usePageConfig */.Gm)();

  var pageConfig = _objectSpread(_objectSpread({}, defaultPageConfig), customPageConfig);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page/* PageConfigProvider */.i$, {
    value: pageConfig,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "twilioLight",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
        pageTitle: "Growth Masters".concat(pageName && " - ".concat(pageName), " | Twilio Segment"),
        pageOG: (OgGrowthMasters_default()),
        pageDescription: "Our culture of close internal alignment, constant communication, and shared incentives delivers sourcing, information, and due diligence advantages to our partners.",
        themeColor: theme.palette.twilio.gray[10],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_NavigationBrandGrowthMasters, {
          after: subnav && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_Subnavigation, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
          children: [children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperDivider, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
      })
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ekuscdy2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var WrapperDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekuscdy1"
} : 0)("padding:10px 40px 0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding:10px 80px 0;}" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "ekuscdy0"
} : 0)("margin:0 auto;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1280px;}" + ( true ? "" : 0));

/* harmony default export */ var Layout_Layout = (Layout);

/***/ }),

/***/ 60114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88392);
/* harmony import */ var _segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94136);
/* harmony import */ var _segment_matcha_recipes_SignupButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77931);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable camelcase */





var copy = {
  heading: "Want to learn more about Twilio Segment?",
  buttonText: "Create a free account",
  description: "Last year, Twilio Segment helped companies implement 86,551 tools, save over 4,000 years of engineering time, and process about 130,000 user events per second. As a part of that, Segment has enabled thousands of PMs to generate accurate customer insights, build better products, and grow their business by democratizing access to data.<br><br>We want to help you, too."
};

var WantToLearnMore = function WantToLearnMore() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_1__/* .Copy */ .CK, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        centered: true,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
          tag: "h3",
          variant: "h2",
          children: copy.heading
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ButtonWrapper, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_recipes_SignupButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            color: "primary",
            additionalParams: {
              utm_campaign: "pm_program",
              utm_medium: "web"
            },
            children: copy.buttonText
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledCopyTextDescription, {
          tag: "p",
          variant: "pLarge",
          dangerouslySetInnerHTML: {
            __html: copy.description
          }
        })]
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP,  true ? {
  target: "eha942h2"
} : 0)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, "{gap:0;}" + ( true ? "" : 0));

var ButtonWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eha942h1"
} : 0)( true ? {
  name: "1og65nf",
  styles: "padding-top:32px;padding-bottom:56px"
} : 0);

var StyledCopyTextDescription = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk,  true ? {
  target: "eha942h0"
} : 0)( true ? {
  name: "1jqg4ge",
  styles: "margin:0 auto;max-width:780px"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (WantToLearnMore);

/***/ }),

/***/ 86052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81333);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33219);





var useInitialCookie = function useInitialCookie() {
  var _useCookie = (0,react_use__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__/* .USER_PROFILE_COOKIE */ .TD),
      _useCookie2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useCookie, 1),
      profileCookie = _useCookie2[0];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      ungate = _useState2[0],
      setUngate = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setUngate(Boolean(profileCookie));
    setLoading(false);
  }, [profileCookie]);
  return [ungate, isLoading, setUngate];
};

/* harmony default export */ __webpack_exports__["Z"] = (useInitialCookie);

/***/ }),

/***/ 94650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_6": function() { return /* reexport */ useCurriculumQuery; },
  "s_": function() { return /* reexport */ useFiltersQuery; },
  "Ct": function() { return /* reexport */ useLessonQuery; },
  "X9": function() { return /* reexport */ useLessonsQuery; },
  "p7": function() { return /* reexport */ useSpeakersQuery; }
});

// UNUSED EXPORTS: DEFAULT_LIMIT, DEFAULT_OFFSET, MAX_RECOMMENDED, createCurriculumQuery, createFetchSpeakersQuery, createFiltersQuery, createLessonsQuery, fetchFilters, fetchLessons, fetchLessonsSlugs, fetchSpeakerLessons, lessonQuery

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/lodash/unionBy.js
var unionBy = __webpack_require__(15316);
var unionBy_default = /*#__PURE__*/__webpack_require__.n(unionBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/growthMasters/queries/filtersQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);








var groupFilters = function groupFilters(filters) {
  var groupedFilters = {};

  var items = sortBy_default()(filters.reduce(function (acc, lesson) {
    var topics = lesson.lessonTopics.map(function (l) {
      return {
        title: l.fields.title,
        id: l.sys.id
      };
    });
    acc = unionBy_default()(acc, topics, "id");
    return acc;
  }, []), function (item) {
    return item.title.toLowerCase();
  });

  groupedFilters.lessonTopics = {
    title: "Filter lessons by topic",
    items: items
  };
  return groupedFilters;
};

var fetchFilters = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var enabled, cachedFetch;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["growthMastersFilters"], function () {
              return client.get("/content/entries/growthMastersLesson").then(function (data) {
                return groupFilters(data);
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createFiltersQuery = function createFiltersQuery(client) {
  return [["growthMasters/filtersQuery"], function () {
    return fetchFilters(client);
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(46152);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
// EXTERNAL MODULE: ../../node_modules/lodash/map.js
var map = __webpack_require__(16760);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
;// CONCATENATED MODULE: ../../libs/api/routes/growthMasters/queries/lessonsQuery.ts
/* provided dependency */ var lessonsQuery_process = __webpack_require__(34406);





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}





var MAX_RECOMMENDED = 9;
var DEFAULT_LIMIT = 6;
var DEFAULT_OFFSET = 0;
/**
 * Helper function that returns all recommended lessons comparing
 * all categories of all lessons.
 * @param lesson LessonResponse
 * @param lessons LessonResponse[]
 * @returns Lesson[]
 */

var listRecommendedLessons = function listRecommendedLessons(lesson, lessons) {
  var recommended = [];
  var badges = lesson.badges;

  var _iterator = _createForOfIteratorHelper(lessons),
      _step;

  try {
    var _loop = function _loop() {
      var single = _step.value; // Remove itself from the search.

      if (lesson.title !== single.title) {
        badges.every(function (rec) {
          var has = single.badges.filter(function (l) {
            return l === rec;
          }); // If category found, add to array just once and breaks the loop.

          if (has.length > 0) {
            recommended.push(single);
            return false;
          }

          return true;
        });
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return shuffle_default()(recommended).slice(0, MAX_RECOMMENDED);
};
/**
 * Helper function that returns all recommended lessons comparing
 * all categories of all lessons.
 * @param lesson LessonResponse
 * @returns Bio
 */


var formatLesson = function formatLesson(lesson) {
  var _author$fields$headsh, _lesson$resources;

  var author = lesson.speakers[0];
  var speaker = {
    type: author.fields.type,
    name: author.fields.name,
    title: author.fields.title,
    headshotUrl: ((_author$fields$headsh = author.fields.headshot) === null || _author$fields$headsh === void 0 ? void 0 : _author$fields$headsh.fields.file.url) || "",
    company: author.fields.company,
    description: author.fields.description,
    linkedInUrl: author.fields.linkedInUrl
  };
  return {
    title: lesson.title,
    slug: lesson.slug,
    videoUrl: lesson.videoUrl,
    badges: lesson.lessonTopics.map(function (topic) {
      return topic.fields.title;
    }),
    videoCoverUrl: lesson.videoThumbnail.fields.file.url,
    speaker: speaker,
    shortDescription: lesson.shortDescription,
    resources: ((_lesson$resources = lesson.resources) === null || _lesson$resources === void 0 ? void 0 : _lesson$resources.map(function (res) {
      return res.fields;
    })) || [],
    featured: lesson.featured || false
  };
};
/**
 * Helper that returns cached array size from speakers/lessons
 * @param client Client
 * @param filters FiltersState
 * @returns lesson's array size
 */


var lessonsArraySize = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, filters) {
    var data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchLessons(client, {
              filters: filters
            });

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data.length);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function lessonsArraySize(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchLessons = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(client) {
    var options,
        enabled,
        searchParams,
        pagination,
        filters,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        cachedFetch,
        _args3 = arguments;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            enabled = Boolean(lessonsQuery_process.env.ENABLE_FS_CACHE);
            searchParams = new URLSearchParams();
            pagination = options.pagination, filters = options.filters;

            if (pagination) {
              _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFSET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
              searchParams.set("limit", limit.toString());
              searchParams.set("offset", offset.toString());
            }

            if (filters) {
              map_default()(filters, function (value, key) {
                var filterParams = value.map(function (item) {
                  return item.value;
                });
                searchParams.set("fields.".concat(key, ".sys.id").concat(filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
              });
            }

            _context3.next = 8;
            return (0,fsCache/* createFsCacheProxy */.c)(["growthMaster/lessonsQuery"], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
              var formatted;
              return regenerator_default().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return client.get("/content/entries/growthMastersLesson/?".concat(searchParams.toString()));

                    case 2:
                      formatted = _context2.sent;
                      return _context2.abrupt("return", formatted.map(function (lesson) {
                        return formatLesson(lesson);
                      }));

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context3.sent;
            return _context3.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchLessons(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchLessonsSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(client) {
    var allLessons;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchLessons(client);

          case 2:
            allLessons = _context4.sent;
            return _context4.abrupt("return", allLessons === null || allLessons === void 0 ? void 0 : allLessons.map(function (lesson) {
              return {
                slug: lesson === null || lesson === void 0 ? void 0 : lesson.slug
              };
            }));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchLessonsSlugs(_x4) {
    return _ref4.apply(this, arguments);
  };
}()));
var fetchSpeakerLessons = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(client, pagination) {
    var allLessons;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchLessons(client, {
              pagination: pagination
            });

          case 2:
            allLessons = _context5.sent;
            return _context5.abrupt("return", allLessons === null || allLessons === void 0 ? void 0 : allLessons.map(function (lesson) {
              return {
                speaker: lesson.speaker,
                lessonLink: lesson.slug
              };
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchSpeakerLessons(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();
var lessonQuery = function lessonQuery(client, slug) {
  return [["growthMaster/lessonQuery", slug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    var allLessons, lesson;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchLessons(client);

          case 3:
            allLessons = _context6.sent;
            lesson = allLessons.find(function (s) {
              return s.slug === slug;
            });

            if (lesson) {
              _context6.next = 7;
              break;
            }

            throw new Error("Lesson data is empty");

          case 7:
            return _context6.abrupt("return", _objectSpread(_objectSpread({}, lesson), {}, {
              recommended: listRecommendedLessons(lesson, allLessons)
            }));

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to find lesson with ".concat(slug, "."));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }))];
};
var useLessonQuery = (0,createQueryHook/* default */.Z)(lessonQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
var createLessonsQuery = function createLessonsQuery(client, limit) {
  return [["growthMaster", "growthMasterLandingSpeakers", limit !== null && limit !== void 0 ? limit : null], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
    var lessons;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return fetchLessons(client);

          case 2:
            lessons = _context7.sent;
            return _context7.abrupt("return", lessons.filter(function (l) {
              return l.featured;
            }).slice(0, limit));

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }))];
};
var useLessonsQuery = (0,createQueryHook/* default */.Z)(createLessonsQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
var createFetchSpeakersQuery = function createFetchSpeakersQuery(client, limit) {
  return [["growthMaster", "growthMasterSpeakers", limit !== null && limit !== void 0 ? limit : null], /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(_ref8) {
      var _ref8$pageParam, pagination, lessons;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref8$pageParam = _ref8.pageParam, pagination = _ref8$pageParam === void 0 ? {} : _ref8$pageParam;
              _context8.next = 3;
              return fetchSpeakerLessons(client, pagination);

            case 3:
              lessons = _context8.sent;
              _context8.next = 6;
              return lessonsArraySize(client);

            case 6:
              _context8.t0 = _context8.sent;
              _context8.t1 = pagination.offset || 0;
              _context8.t2 = limit;
              _context8.t3 = lessons;
              return _context8.abrupt("return", {
                total: _context8.t0,
                skip: _context8.t1,
                limit: _context8.t2,
                items: _context8.t3
              });

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x7) {
      return _ref9.apply(this, arguments);
    };
  }()];
};
var useSpeakersQuery = (0,createInfinityQueryHook/* default */.Z)(createFetchSpeakersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
var createCurriculumQuery = function createCurriculumQuery(client, filters) {
  return [["growthMaster", "growthMasterCurriculum", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(_ref10) {
      var _ref10$pageParam, pagination, lessons;

      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _ref10$pageParam = _ref10.pageParam, pagination = _ref10$pageParam === void 0 ? {} : _ref10$pageParam;
              _context9.next = 3;
              return fetchLessons(client, {
                pagination: pagination,
                filters: filters
              });

            case 3:
              lessons = _context9.sent;
              _context9.next = 6;
              return lessonsArraySize(client, filters);

            case 6:
              _context9.t0 = _context9.sent;
              _context9.t1 = pagination.offset || 0;
              _context9.t2 = DEFAULT_LIMIT;
              _context9.t3 = lessons;
              return _context9.abrupt("return", {
                total: _context9.t0,
                skip: _context9.t1,
                limit: _context9.t2,
                items: _context9.t3
              });

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x8) {
      return _ref11.apply(this, arguments);
    };
  }()];
};
var useCurriculumQuery = (0,createInfinityQueryHook/* default */.Z)(createCurriculumQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/growthMasters/queries/index.ts



/***/ }),

/***/ 33219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oc": function() { return /* binding */ fetchProfileCookie; },
/* harmony export */   "TD": function() { return /* binding */ USER_PROFILE_COOKIE; },
/* harmony export */   "WF": function() { return /* binding */ fetchUserRegisteredByEmail; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17397);
/* harmony import */ var _tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16297);




var USER_PROFILE_COOKIE = "user-profile-enabled";
var fetchUserRegisteredByEmail = /*#__PURE__*/function () {
  var _ref = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(signal, options) {
    var eventName, formId, email, response;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            eventName = options.eventName, formId = options.formId, email = options.email;
            _context.next = 3;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/profile/").concat(eventName, "/").concat(formId), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function (err) {
              return err.message;
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchUserRegisteredByEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Decided to not check the endpoint or even the cookie value at this time.
 * The content is public anyways, however if we decide to `gate` the content we will need to make
 * this a HTTP cookie and control all data coming form /backend using this cookie.
 * Right now this function is just creating a cookie in the BE to be read in the FE through `useCookie`
 * @param email user email
 * @returns success or error message from server
 */

var fetchProfileCookie = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(signal, email) {
    var successMessage, errorMessage, jwt;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            successMessage = "user logged in";
            errorMessage = "user not logged in";

            if (!(0,_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(USER_PROFILE_COOKIE)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", successMessage);

          case 4:
            _context2.next = 6;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/profile/auth"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return errorMessage;
            });

          case 6:
            jwt = _context2.sent;
            return _context2.abrupt("return", jwt.message || "");

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchProfileCookie(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 60777:
/***/ (function(module) {

module.exports = "/_next/static/images/OgGrowthMasters-2a58cb594dc55ab300b61bd9183e11a0.png";

/***/ })

}]);